import { render, staticRenderFns } from "./CompanyRequestView.vue?vue&type=template&id=a3f2d95a&"
import script from "./CompanyRequestView.vue?vue&type=script&lang=js&"
export * from "./CompanyRequestView.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRequestView.vue?vue&type=style&index=0&id=a3f2d95a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports